import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ApplicationInfo from "../../Pages/Submitter/ApplicationIformation/ApplicationInfo";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";
import ApplicantInfo from "../../Pages/Submitter/ApplicationIformation/ApplicantInfo";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import {
  UpdateAI_NT_ApI_ApplicantInformation,
  ValidateApplicationInformationPage,
} from "../../Redux/Reducers/Submitter/ApplicantInformation";
import $ from "jquery";
import PopupAHSF from "../../Components/PopupAHSF";
import ValidationView from "../../Components/ValidationView";
import RichTextEditor from "../../Components/RichTextEditor";

function ApplicationInformation() {
  const location = useLocation();
  console.log("ssssssssdwwwwwdwdewd", location.state?.from);
  const dispatch = useDispatch();
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false);
  const navigate = useNavigate();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false); // Popup visibility state

  const lang = useSelector((state) => state.languageReducer.Language);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ApplicantInformation: state.ApplicantInformation.ApplicantInformation,
      ValidateApplicantInformationList:
        state.ApplicantInformation.ValidateApplicantInformationList,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  console.log(state.ApplicationInformation, "qaqaqaqa", state.ActiveRound);
  /*************  The Save Data Without Validation   ****************/
  // const SaveDataPage = async () => {
  //   dispatch(
  //     UpdateAI_NT_ApI_ApplicantInformation({
  //       ...state.ApplicantInformation,
  //     })
  //   );
  // };
  /*************  The Save Data Without Validation   ****************/
  useEffect(() => {}, [location.state?.from]);
  const SaveDataPage = async (withValidate) => {
    const saved = await dispatch(
      UpdateAI_NT_ApI_ApplicantInformation({
        ...state.ApplicantInformation,
      })
    );

    if (withValidate == true && saved.payload.code == 200) {
      const validate = await dispatch(
        ValidateApplicationInformationPage(
          localStorage.getItem("ApplicationInformationId")
        )
      );

      if (validate.payload.length == 0) {
        $(".WorkInformationAndAcademic").trigger("click");

        navigate("/ResearchersAward/WorkInformationAndAcademic");
      } else {
        setPopupComponentValidationViewStatus(true);
        setisPopupOpenStatus(true);
      }
    }
  };
  const closePopupComponentValidationViewStatus = () => {
    // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };

  const disabled = state.ActiveRound;

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Application Information"
        titleNameAR="معلومات الطلب"
        lang={lang}
        child={[<ApplicationInfo />]}
      />
      <SharedDiv
        showTitle={true}
        titleNameEN="Applicant Information"
        titleNameAR="معلومات مقدم الطلب"
        lang={lang}
        titleName="معلومات الطلب"
        child={[<ApplicantInfo disabled={disabled} />]}
      />
      {!disabled ? (
        <div className="containerButtonMAin">
          <div className={`SaveButtonMarks ${lang === "ar" ? "rtl" : "ltr"}`}>
            <ButtonAHSF
              type={"submitter"}
              fieldsName="SaveButton"
              lang={lang}
              text="حفظ"
              onClick={() => {
                SaveDataPage(false);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: lang == "ar" ? "تم الحفظ بنجاح" : "Saved Successfully",
                  showConfirmButton: false,
                  timer: 1500,
                  // width: "500px",
                });
              }}
              disabled={false}
              title={"حفظ"}
              show={true}
            />
          </div>

          <ButtonAHSF
            type={"submitter"}
            fieldsName="NextButton"
            lang={lang}
            onClick={() => {
              SaveDataPage(true);
              // navigate("/researcher/WorkInformationAndAcademic");
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}


      <PopupAHSF
        title={
          lang == "ar"
            ? "يرجى تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        }
        componentBody={
          <ValidationView
            ValidationList={state.ValidateApplicantInformationList}
          />
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={
          PopupComponentValidationViewStatus &&
          state.ValidateApplicantInformationList?.length > 0
        } // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />



      {/* <RichTextEditor/> */}
    </>
  );
}

export default ApplicationInformation;
